<div class="pod-event-container">
    <ms-popular-bets-pod-header [isEpcotEnabled]="isEpcotEnabled" [pod]="pod" />
    @if (pod.summary) {
        <ms-popular-bets-pod-summary
            [summary]="pod.summary"
            [class.pod-with-option]="pod.showOptionPick"
            [class.pod-summary-padding]="!pod.isAllPodAreSameType" />
    }
    <div class="popular-bets-pod-events" [style.height.px]="minHeight" [class.odds-selection-hidden]="!pod.showOptionPick">
        <ms-popular-bets-pod-event
            class="popular-bets-pod-event"
            *rxFor="let event of pod.events | slice: 0 : pod.visibleOptionsLimit; trackBy: trackByEvent; let index = index"
            [class.hide-option]="!pod.showOptionPick"
            [class.show-more]="pod.showMoreLessButtonVisible"
            [event]="event"
            [showOptionPick]="pod.showOptionPick"
            [tracking]="getTrackingDetails(pickSelectionType.Single, index + 1, pod.events.length)"
            [isEpcotEnabled]="isEpcotEnabled"
            [podOptionTeamInfo]="pod.podOptionTeamInfo" />
    </div>
</div>
<div>
    @if (pod.showMoreLessButtonVisible) {
        <ms-popular-bets-pod-show-more
            class="popular-bets-pod-show-more"
            [totalCount]="pod.eventsCount"
            [defaultCount]="pod.defaultNoOfLegs"
            [isEpcotEnabled]="isEpcotEnabled"
            (expandChange)="onShowMoreLessButtonToggle($event)" />
    }

    <ms-popular-bets-pod-add-to-betslip
        class="popular-bets-add-to-betslip"
        [class.show-more-less-visible]="pod.showMoreLessButtonVisible"
        [podType]="pod.podType"
        [enableSinglePickSelection]="pod.showOptionPick"
        [podEvents]="pod.events"
        [tracking]="getTrackingDetails(pickSelectionType.All, 0, pod.events.length)"
        [isEpcotEnabled]="isEpcotEnabled" />
</div>
